import { useState } from 'react';
import { startLoading, stopLoading } from 'src/utils/loading';
import { useListStore } from 'src/hooks/use-list-table';

export const useItemsStore = (searchState, fetchFunction, params = {}) => {
  const [state, setState] = useState({
    items: [],
    loading: false,
  });

  useListStore(searchState, (payload, isMounted) => {
    setState((prev) => ({ ...prev, loading: true }));
    startLoading();

    fetchFunction(
      payload,
      params,
      (endPoint) => {
        setState((prev) => ({ ...prev, endpoint: endPoint }));
      },
      (results) => {
        if (isMounted) {
          setState((prev) => ({ ...prev, items: results ?? [], loading: false }));
          stopLoading();
        }
      },
      () => {
        if (isMounted) {
          setState((prev) => ({ ...prev, items: [], loading: false }));
          stopLoading();
        }
      }
    );
  });

  return {
    ...state,
    query: searchState.filters.query,
  };
};